import { render } from "./[id].vue?vue&type=template&id=62b1696c"
import script from "./[id].vue?vue&type=script&lang=js"
export * from "./[id].vue?vue&type=script&lang=js"

import "./[id].vue?vue&type=style&index=0&id=62b1696c&lang=css"

import exportComponent from "/home/runner/work/bot-v2/bot-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__